import { Box, Button, Stack, TextField, Typography } from '@mui/material';
import { useState } from 'react';
import ActivityIndicator from '../../components/activityIndicator';
import { toast } from 'react-toastify';
import AuthServices from '../../services/auth.services';
import { useFormik } from 'formik';
import * as yup from 'yup';

function LoginForm({
  mobileNumber,
  setMobileNumber,
  setOtpSent,
}: {
  mobileNumber: string;
  setMobileNumber: any;
  setOtpSent: any;
}) {
  const [loading, setLoading] = useState(false);

  const validationSchema = yup.object({
    mobileNumber: yup
      .string()
      .length(10, 'Phone number must be 10 digits')
      .required('Phone number is required'),
  });

  const formik = useFormik({
    initialValues: {
      mobileNumber: '',
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {},
  });

  const handleSendOtp = async () => {
    try {
      setLoading(true);
      setMobileNumber(formik.values.mobileNumber);
      if (formik.values.mobileNumber?.trim()?.length !== 10)
        return toast.warn('Enter a valid 10 digit mobile number');
      const isOtpSent = await AuthServices.sendOTP(formik.values.mobileNumber);
      if (isOtpSent) {
        setOtpSent(true);
        // toast.success('OTP has been sent');
      } else {
        toast.error('Phone number is not registered.');
      }
    } catch (error) {
      console.log(error);
      toast.error('Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <ActivityIndicator />}
      <Stack color="white" flex={1}>
        <Box my={3} sx={{ display: 'flex', flexDirection: 'column', flex: 1, gap: 2 }}>
          <TextField
            fullWidth
            required
            id="mobileNumber"
            name="mobileNumber"
            label="Mobile Number"
            value={formik.values.mobileNumber}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            type="tel"
            inputMode="tel"
            FormHelperTextProps={{
              style: {
                fontSize: '14px',
              },
            }}
            InputProps={{
              style: {
                fontSize: '22px',
              },
            }}
            InputLabelProps={{
              style: {
                fontSize: '18px',
                color: '#000',
              },
            }}
            error={formik.touched.mobileNumber && Boolean(formik.errors.mobileNumber)}
            helperText={formik.touched.mobileNumber && formik.errors.mobileNumber}
            sx={{
              '& .MuiOutlinedInput-root': {
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#000',
                  borderRadius: 2,
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#000',
                },
              },
              '& .MuiInputLabel-outlined': {
                // color: '#fff',
              },
              '& label.Mui-focused': {
                // color: '#fff', // Change label color when input is focused
                borderColor: '#000',
              },
              '&:hover label': {
                // color: '#fff', // Change label color on hover
                borderColor: '#000',
              },
            }}
          />
          <Typography fontWeight={'500'} color="primary" variant="body2">
            By continuing, I agree to IFB's{' '}
            <a className="underline" href="/">
              Privary Policy
            </a>{' '}
            &{' '}
            <a className="underline" href="/">
              Terms of use
            </a>
            .
          </Typography>
          <Button
            onClick={handleSendOtp}
            disabled={formik.values.mobileNumber?.trim()?.length !== 10 || loading}
            variant="contained"
            size="large"
            sx={{
              borderRadius: 10,
              px: 3,
              textTransform: 'none',
              alignSelf: 'end',
              // fontWeight: '500'
              ':disabled': {
                color: '#fff',
                bgcolor: '#000',
              },
            }}
          >
            Continue
          </Button>
        </Box>
      </Stack>
    </>
  );
}

export { LoginForm };
